export { default, transformOwaLinkProps } from "./OwaLink";
export type { OwaLinkProps, OwaLinkPropsWithoutChildren } from "./OwaLink";
